"use client";

import { useClientContext } from "@/context/ClientContext";
import { useClientBrand } from "@/hooks/useClientBrand";

/**
 * Thin component that reads the active client from context and applies
 * its brand colors as CSS custom properties on <html>. Also pipes the
 * brand kit's logoUrl into ClientContext so the sidebar can display it.
 * Renders nothing.
 *
 * Place inside <ClientProvider> in the root layout so brand theming
 * activates whenever a client context is selected.
 */
export function ClientBrandApplier() {
  const { clientId, setBrandLogoUrl } = useClientContext();
  useClientBrand(clientId, setBrandLogoUrl);

  return null;
}
